unit DonationDataEdit;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  Vcl.Controls,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  Data.DB,
  WEBLib.DB,
  WEBLib.DBCtrls,
  WEBLib.WebCtrls,
  WebForm.Core, WEBLib.ExtCtrls,
  XData.Web.Dataset, XData.Web.JsonDataset,
  Essentials.Web.Attributes.Form,
  GA.Return.Types,
  XData.Web.Client;

type
  TDonorSnapshot = record
    DonorId: Integer;
    ClaimStatus: string;
    DateOfDeath: TDate;
    Kind: string;
    Add1: string;
    PostCode: string;
  end;

  TDonationValidation = class
    AmountValid: Boolean;
    TransactionDateValid: Boolean;
    PaymentMethodValid: Boolean;
    DonationKindValid: Boolean;
    function PassesValidation: Boolean;
    procedure ValidateAmount(aAmount: string; out aErrorText: string);
    procedure ValidatePaymentMethod(aComboItemIndex: Integer; out aErrorText: string);
    procedure ValidateDonationDate(aDonationDate, aDateOfDeath: TDate; out aErrorText: string);
    procedure ValidateDonationKind(aComboItemIndex: Integer; aValue: string; out aErrorText: string);
    constructor Create;
  end;

  TDonationDataEditForm = class(TCoreWebForm)
    AmountDonation: TDBEdit;
    DonorPostCode: TDBEdit;
    SaveButton: TButton;
    CancelButton: TButton;
    ClaimStatus: TDBEdit;
    EditDataSource: TDataSource;
    DonationDateEdit: TDBDateTimePicker;
    ErrorMessageDonationDate: TLabel;
    ErrorMessageAmount: TLabel;
    ErrorMessageDonationKind: TLabel;
    ErrorMessagePaymentMethod: TLabel;
    SponsoredEditDB: TDBCheckBox;
    NonGiftaidableByCustomerRequestEdit: TDBCheckBox;
    BankingDateEdit: TDBDateTimePicker;
    OtherDonationKindEdit: TDBEdit;
    PaymentMethodNoteEdit: TDBEdit;
    DonationKindCombo: TDBLookupComboBox;
    PaymentMethodCombo: TDBLookupComboBox;
    CommentMemo: TDBMemo;
    AnalysisCode1Combo: TDBComboBox;
    AnalysisCode2Combo: TDBComboBox;
    BankingReference2Edit: TDBEdit;
    BankingReferenceCombo: TDBComboBox;
    DonationClaimStatusDisplay: TEdit;
    DonorClaimStatusDisplay: TEdit;
    DataState: THTMLSpan;
    DonationRefresh: TTimer;
    ClaimStatusPreviewTimer: TTimer;
    DonationClaimStatusError: TLabel;
    procedure AmountDonationChange(Sender: TObject);
    procedure AmountDonationKeyPress(Sender: TObject; var Key: Char);
    procedure CancelButtonClick(Sender: TObject);
    procedure CloseButtonClick(Sender: TObject);
    procedure DonationDateEditChange(Sender: TObject);
    procedure EditDataSourceDataChange(Sender: TObject; Field: TField);
    procedure SaveButtonClick(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure DonationKindComboChange(Sender: TObject);
    procedure OtherDonationKindEditExit(Sender: TObject);
    procedure PaymentMethodNoteEditExit(Sender: TObject);
    procedure PaymentMethodComboChange(Sender: TObject);
    procedure NonGiftaidableByCustomerRequestEditClick(Sender: TObject);
    procedure BankingDateEditExit(Sender: TObject);
    procedure DonationDateEditExit(Sender: TObject);
    procedure DonationRefreshTimer(Sender: TObject);
    procedure ClaimStatusPreviewTimerTimer(Sender: TObject);
    [async]
    procedure DonationClaimStatusDisplayClick(Sender: TObject); async;
  private
    { Private declarations }
    FValidation: TDonationValidation;
    FEditDataApplyUpdates: boolean;
    FAttributesForm: TEssentialsAttributesForm;
    FDonorSnapshot: TDonorSnapshot;
    FSingleDeclarationId: integer;
    FDonationId: integer;
    FAllowEdit: Boolean;
    FLockedViewMode: Boolean;
    FClaimStatusPreviewGeneration: Integer;
    FLastClaimStatusPreviewFingerprint: string;
    FClaimStatusPreviewForDisplay: Boolean;
    FPreviewClaimStatus: string;
    FPreviewErrorText: string;
    FClaimStatusRecomputed: Boolean;
    function FieldAffectsClaimStatus(const AField: TField): Boolean;
    function IsPersistedClaimStatusLocked: Boolean;
    function ClaimStatusExpectsErrorText(const AClaimStatus: string): Boolean;
    function BuildClaimStatusPreviewRequest: TDonationClaimStatusPreviewRequest;
    procedure ApplyClaimStatusPreviewResult(const AClaimStatus, AErrorText: string);
    procedure ApplyPersistedClaimStatusErrorText(const APersistedClaimStatus, APreviewClaimStatus,
      AErrorText: string);
    procedure ShowClaimStatusCalculating(const ADisplayInLockedView: Boolean = False);
    procedure SetDataSet(Value: TDataSet);
    [async]
    procedure LoadEssentials; async;
    procedure CheckValidations;
    procedure DetermineOtherDonationKindVisibility;
    procedure DeterminePaymentMethodNoteVisibility;
    procedure DetermineConditionalUIVisibility;
    function IsGiftAidUnclaimed: Boolean;
    procedure InitAttributesForm;
    procedure SetAllowEdit(AAllowEdit: Boolean);
    procedure ViewModeOn;
    procedure EditModeOn;
    procedure EnterLockedViewMode;
    [async]
    procedure EnterLockedViewModeAfterSave; async;
    procedure EnterEditMode;
    function CanUseEditToggle: Boolean;
    function CanOpenInterrogation: Boolean;
    procedure SetPrimaryActionButton(const ACaption: string);
    procedure SetEditingControlsEnabled(const AEnabled: Boolean);
    procedure UpdatePrimaryActionEnabled;
    function IsReadOnlyMode: Boolean;
    procedure UpdateDataState;
    procedure UpdateClaimStatusDisplay;
    procedure ShowPersistedClaimStatusDisplay;
    procedure SetDonationClaimStatusError(const AText: string);
    procedure ScheduleClaimStatusPreview;
    procedure ScheduleClaimStatusDisplayRefresh;
    procedure CancelClaimStatusPreview;
    function IsClaimStatusPreviewPending: Boolean;
    [async]
    procedure RefreshClaimStatusPreviewFromServer(const ADisplayInLockedView: Boolean = False); async;
    procedure SetDonorClaimStatus(const AValue: string);
    procedure SyncPreviewIdsFromDataSet;
    procedure SyncCheckboxFieldsToDataset;
    procedure EnsureDatasetEditMode;
    procedure SyncFieldsToDatasetBeforeSave;
    [async]
    procedure CaptureSingleDeclarationIdForSave; async;
    [async]
    procedure OpenClaimStatusInterrogation(const APreviewRequest: TDonationClaimStatusPreviewRequest = nil); async;
    [async]
    procedure TrySave; async;
    public
    { Public declarations }
    constructor Create(aOwner: TComponent); override;
    destructor Destroy; override;
    procedure CheckEdit;
    property DataSet: TDataSet write SetDataSet;
    property EditDataApplyUpdates: boolean read FEditDataApplyUpdates;
    property ClaimStatusRecomputed: Boolean read FClaimStatusRecomputed;
    property AllowEdit: Boolean write SetAllowEdit;

    procedure SetDonorSnapshot(const ADonorKind, ADonorClaimStatus, AAdd1, APostCode: string;
      const ADateOfDeath: TDate);
    property SingleDeclarationId: integer read FSingleDeclarationId write FSingleDeclarationId;
  protected procedure LoadDFMValues; override; end;

var
  DonationDataEditForm: TDonationDataEditForm;

implementation

{$R *.dfm}

uses
  DonationList, SMX.Web.Document.Utils, GA.Web.Utils,
  Essentials.Web.Shared, MainDataModule,
  System.Rtti, System.TypInfo, Essentials.Web.Manager, Essentials.RequiredFields.UtilityUnit,
  System.Math, GA.Rules, DonationClaimStatusInterrogationForm;

procedure TDonationDataEditForm.AmountDonationChange(Sender: TObject);
begin
  CheckEdit;
end;

procedure TDonationDataEditForm.AmountDonationKeyPress(Sender: TObject; var
    Key: Char);
begin
  if (Pos('.', AmountDonation.Text) > 0) and (Key = '.') then
  begin
    Key := #0;
    exit;
  end;

  if (not (Key in ['0'..'9','.']) or (Length(TEdit(Sender).Text) > 7)) then
  begin
    TDocUtils.setControlValidity('AmountDonation', vsInvalid);
    Key := #0;
  end
  else
  begin
    TDocUtils.setControlValidity('AmountDonation', vsValid);
  end;
end;

procedure TDonationDataEditForm.CancelButtonClick(Sender: TObject);
begin
  inherited;
  CloseButtonClick(Sender);
end;

procedure TDonationDataEditForm.CloseButtonClick(Sender: TObject);
begin
  inherited;
  if Assigned(EditDataSource.DataSet) and (EditDataSource.DataSet.State in dsEditModes) then
    EditDataSource.DataSet.Cancel;
  ModalResult := mrOk;
end;

constructor TDonationDataEditForm.Create(aOwner: TComponent);
begin
  inherited;
  FValidation := TDonationValidation.Create;
  FAllowEdit := True;
  FLockedViewMode := False;
  FClaimStatusPreviewGeneration := 0;
  FLastClaimStatusPreviewFingerprint := '';
  FClaimStatusPreviewForDisplay := False;
  FPreviewClaimStatus := '';
  FPreviewErrorText := '';
  FClaimStatusRecomputed := False;
end;

function TDonationDataEditForm.FieldAffectsClaimStatus(const AField: TField): Boolean;
begin
  if not Assigned(AField) then
    Exit(True);

  Result := SameText(AField.FieldName, 'TransactionDate') or
    SameText(AField.FieldName, 'Amount') or
    SameText(AField.FieldName, 'Sponsored') or
    SameText(AField.FieldName, 'DonationKind') or
    SameText(AField.FieldName, 'NonGiftaidableByCustomerRequest');
end;

function TDonationDataEditForm.IsPersistedClaimStatusLocked: Boolean;
var
  lClaimStatusField: TField;
begin
  Result := False;
  if not Assigned(EditDataSource.DataSet) or not EditDataSource.DataSet.Active then
    Exit;
  lClaimStatusField := EditDataSource.DataSet.FindField('ClaimStatus');
  if lClaimStatusField = nil then
    Exit;
  Result := TDonationUIUtils.DonationClaimStatusIsLocked(lClaimStatusField.AsString);
end;

function TDonationDataEditForm.ClaimStatusExpectsErrorText(const AClaimStatus: string): Boolean;
begin
  Result := SameText(AClaimStatus, 'NonGiftAidable') or
    SameText(AClaimStatus, 'NGACustomerRequest') or
    SameText(AClaimStatus, 'Invalid') or
    SameText(AClaimStatus, 'TooOld') or
    SameText(AClaimStatus, 'Failed');
end;

procedure TDonationDataEditForm.ApplyClaimStatusPreviewResult(const AClaimStatus, AErrorText: string);
begin
  FPreviewClaimStatus := Trim(AClaimStatus);
  FPreviewErrorText := Trim(AErrorText);
  DonorClaimStatusDisplay.Text := Trim(FDonorSnapshot.ClaimStatus);
  DonationClaimStatusDisplay.Text := TDonationUIUtils.ClaimStatusDisplayText(AClaimStatus);
  SetDonationClaimStatusError(Trim(AErrorText));
  CheckEdit;
end;

procedure TDonationDataEditForm.ApplyPersistedClaimStatusErrorText(const APersistedClaimStatus,
  APreviewClaimStatus, AErrorText: string);
var
  lPersisted: string;
  lPreview: string;
  lErrorText: string;
begin
  lPersisted := Trim(APersistedClaimStatus);
  lPreview := Trim(APreviewClaimStatus);
  lErrorText := Trim(AErrorText);

  FPreviewClaimStatus := lPersisted;
  DonorClaimStatusDisplay.Text := Trim(FDonorSnapshot.ClaimStatus);
  DonationClaimStatusDisplay.Text := TDonationUIUtils.ClaimStatusDisplayText(lPersisted);

  if (lErrorText <> '') and SameText(lPersisted, lPreview) then
  begin
    FPreviewErrorText := lErrorText;
    SetDonationClaimStatusError(lErrorText);
  end;

  if not ((lErrorText <> '') and SameText(lPersisted, lPreview)) then
  begin
    FPreviewErrorText := '';
    SetDonationClaimStatusError('');
  end;
end;

procedure TDonationDataEditForm.ShowClaimStatusCalculating(const ADisplayInLockedView: Boolean);
begin
  if ADisplayInLockedView then
    SetDonationClaimStatusError(TDonationUIUtils.CLAIM_STATUS_CALCULATING)
  else
  begin
    DonationClaimStatusDisplay.Text := TDonationUIUtils.CLAIM_STATUS_CALCULATING;
    SetDonationClaimStatusError('');
  end;
end;

function TDonationDataEditForm.BuildClaimStatusPreviewRequest: TDonationClaimStatusPreviewRequest;
var
  lDonationKind: string;
begin
  Result := TDonationClaimStatusPreviewRequest.Create;
  lDonationKind := Trim(DonationKindCombo.Value);
  if lDonationKind = '' then
    lDonationKind := Trim(EditDataSource.DataSet.FieldByName('DonationKind').AsString);

  Result.DonorId := FDonorSnapshot.DonorId;
  Result.DonationId := FDonationId;
  Result.TransactionDate := TDonationUIUtils.PreviewRequestDate(DonationDateEdit.Date);
  Result.Amount := EditDataSource.DataSet.FieldByName('Amount').AsFloat;
  Result.Sponsored := SponsoredEditDB.Checked;
  Result.NonGiftaidableByCustomerRequest := NonGiftaidableByCustomerRequestEdit.Checked;
  // Donor is not edited on this form; load donor from DB on preview so results match save/recompute.
  Result.InlineDonor := False;
  Result.DonationKind := lDonationKind;
  Result.CurrentClaimStatus := Trim(EditDataSource.DataSet.FieldByName('ClaimStatus').AsString);
end;

procedure TDonationDataEditForm.SetDonorSnapshot(const ADonorKind, ADonorClaimStatus, AAdd1, APostCode: string;
  const ADateOfDeath: TDate);
begin
  FDonorSnapshot.Kind := Trim(ADonorKind);
  SetDonorClaimStatus(ADonorClaimStatus);
  FDonorSnapshot.Add1 := Trim(AAdd1);
  FDonorSnapshot.PostCode := Trim(APostCode);
  FDonorSnapshot.DateOfDeath := ADateOfDeath;
  FLastClaimStatusPreviewFingerprint := '';
end;

procedure TDonationDataEditForm.EditDataSourceDataChange(Sender: TObject; Field: TField);
begin
  // Keep conditional controls in sync with bound field values,
  // especially on initial dataset bind in viewing mode.
  DetermineConditionalUIVisibility;
  if FieldAffectsClaimStatus(Field) then
    UpdateClaimStatusDisplay;

  if IsReadOnlyMode or FLockedViewMode then
    CancelButton.Caption := 'Close'
  else
    CancelButton.Caption := 'Cancel';

  UpdateDataState;
end;

procedure TDonationDataEditForm.SetDonorClaimStatus(const AValue: string);
begin
  FDonorSnapshot.ClaimStatus := AValue;
  DonorClaimStatusDisplay.Text := Trim(AValue);
end;

procedure TDonationDataEditForm.SyncPreviewIdsFromDataSet;
begin
  FDonorSnapshot.DonorId := 0;
  FDonationId := 0;
  if not Assigned(EditDataSource.DataSet) then
    Exit;
  if EditDataSource.DataSet.FindField('DonorId') <> nil then
    FDonorSnapshot.DonorId := EditDataSource.DataSet.FieldByName('DonorId').AsInteger;
  if EditDataSource.DataSet.FindField('Id') <> nil then
    if not EditDataSource.DataSet.FieldByName('Id').IsNull then
      FDonationId := EditDataSource.DataSet.FieldByName('Id').AsInteger;
end;

procedure TDonationDataEditForm.EnsureDatasetEditMode;
begin
  if not Assigned(EditDataSource.DataSet) then
    Exit;
  if not (EditDataSource.DataSet.State in dsEditModes) then
    EditDataSource.DataSet.Edit;
end;

procedure TDonationDataEditForm.SyncCheckboxFieldsToDataset;
begin
  if not Assigned(EditDataSource.DataSet) then
    Exit;
  if not (EditDataSource.DataSet.State in dsEditModes) then
    Exit;

  if EditDataSource.DataSet.FindField('Sponsored') <> nil then
    EditDataSource.DataSet.FieldByName('Sponsored').AsBoolean := SponsoredEditDB.Checked;
  if EditDataSource.DataSet.FindField('NonGiftaidableByCustomerRequest') <> nil then
    EditDataSource.DataSet.FieldByName('NonGiftaidableByCustomerRequest').AsBoolean :=
      NonGiftaidableByCustomerRequestEdit.Checked;
end;

procedure TDonationDataEditForm.SyncFieldsToDatasetBeforeSave;
var
  lDonationDate: TDate;
  lBankingDate: TDate;
  lBankingDateHasValue: Boolean;
begin
  if not Assigned(EditDataSource.DataSet) then
    Exit;

  lDonationDate := TGARulesUtils.MinDateCheck(DonationDateEdit.Date);
  DonationDateEdit.Date := lDonationDate;
  lBankingDateHasValue := (Trim(BankingDateEdit.Text) <> '') and
    (not SameText(Trim(BankingDateEdit.Text), 'dd/mm/yyyy')) and
    (BankingDateEdit.Date > 0);
  if lBankingDateHasValue then
  begin
    lBankingDate := BankingDateEdit.Date;
    lBankingDate := TGARulesUtils.MinDateCheck(lBankingDate);
    BankingDateEdit.Date := lBankingDate;
  end;

  EnsureDatasetEditMode;

  if EditDataSource.DataSet.FindField('TransactionDate') <> nil then
    EditDataSource.DataSet.FieldByName('TransactionDate').AsDateTime := lDonationDate;
  if EditDataSource.DataSet.FindField('BankingDate') <> nil then
  begin
    if lBankingDateHasValue then
      EditDataSource.DataSet.FieldByName('BankingDate').AsDateTime := lBankingDate
    else
      EditDataSource.DataSet.FieldByName('BankingDate').Clear;
  end;

  SyncCheckboxFieldsToDataset;
end;

procedure TDonationDataEditForm.SetDonationClaimStatusError(const AText: string);
const
  S_REFRESH_CLAIM_STATUS_HINT =
    'This status has no reason text. Refresh claim statuses for this donor.';
var
  lText: string;
begin
  lText := Trim(AText);
  if (lText = '') and ClaimStatusExpectsErrorText(Trim(FPreviewClaimStatus)) then
    lText := S_REFRESH_CLAIM_STATUS_HINT;

  DonationClaimStatusError.Caption := TDonationUIUtils.ClaimStatusErrorDisplayText(lText);
end;

procedure TDonationDataEditForm.ShowPersistedClaimStatusDisplay;
var
  LClaimStatus: string;
  LErrorText: string;
begin
  DonorClaimStatusDisplay.Text := Trim(FDonorSnapshot.ClaimStatus);

  if not Assigned(EditDataSource.DataSet) or (EditDataSource.DataSet.FindField('ClaimStatus') = nil) then
    Exit;

  LClaimStatus := Trim(EditDataSource.DataSet.FieldByName('ClaimStatus').AsString);
  FPreviewClaimStatus := LClaimStatus;
  DonationClaimStatusDisplay.Text := TDonationUIUtils.ClaimStatusDisplayText(LClaimStatus);

  LErrorText := '';
  if EditDataSource.DataSet.FindField('ErrorText') <> nil then
    LErrorText := Trim(EditDataSource.DataSet.FieldByName('ErrorText').AsString);
  if (LErrorText = '') and ClaimStatusExpectsErrorText(LClaimStatus) then
    FLastClaimStatusPreviewFingerprint := '';
  FPreviewErrorText := LErrorText;
  SetDonationClaimStatusError(LErrorText);
end;

procedure TDonationDataEditForm.ScheduleClaimStatusPreview;
begin
  if IsReadOnlyMode or FLockedViewMode or IsPersistedClaimStatusLocked then
    Exit;

  FClaimStatusPreviewForDisplay := False;
  ClaimStatusPreviewTimer.Enabled := False;
  ClaimStatusPreviewTimer.Enabled := True;
end;

procedure TDonationDataEditForm.ScheduleClaimStatusDisplayRefresh;
var
  lClaimStatus: string;
  lErrorText: string;
begin
  if IsReadOnlyMode then
    Exit;
  if not Assigned(EditDataSource.DataSet) or (EditDataSource.DataSet.FindField('ClaimStatus') = nil) then
    Exit;

  lClaimStatus := Trim(EditDataSource.DataSet.FieldByName('ClaimStatus').AsString);
  if not ClaimStatusExpectsErrorText(lClaimStatus) then
    Exit;

  lErrorText := '';
  if EditDataSource.DataSet.FindField('ErrorText') <> nil then
    lErrorText := Trim(EditDataSource.DataSet.FieldByName('ErrorText').AsString);
  if lErrorText <> '' then
    Exit;

  FClaimStatusPreviewForDisplay := True;
  ClaimStatusPreviewTimer.Enabled := False;
  ClaimStatusPreviewTimer.Enabled := True;
end;

procedure TDonationDataEditForm.CancelClaimStatusPreview;
begin
  ClaimStatusPreviewTimer.Enabled := False;
  Inc(FClaimStatusPreviewGeneration);
end;

function TDonationDataEditForm.IsClaimStatusPreviewPending: Boolean;
begin
  Result := ClaimStatusPreviewTimer.Enabled or
    SameText(Trim(DonationClaimStatusDisplay.Text), TDonationUIUtils.CLAIM_STATUS_CALCULATING) or
    SameText(Trim(DonationClaimStatusError.Caption), TDonationUIUtils.CLAIM_STATUS_CALCULATING);
end;

procedure TDonationDataEditForm.ClaimStatusPreviewTimerTimer(Sender: TObject);
var
  lForDisplay: Boolean;
begin
  ClaimStatusPreviewTimer.Enabled := False;
  lForDisplay := FClaimStatusPreviewForDisplay;
  FClaimStatusPreviewForDisplay := False;
  RefreshClaimStatusPreviewFromServer(lForDisplay);
end;

procedure TDonationDataEditForm.UpdateClaimStatusDisplay;
begin
  if not Assigned(EditDataSource.DataSet) then
    Exit;

  if IsReadOnlyMode or FLockedViewMode or IsPersistedClaimStatusLocked then
  begin
    ShowPersistedClaimStatusDisplay;
    ScheduleClaimStatusDisplayRefresh;
    Exit;
  end;

  ScheduleClaimStatusPreview;
end;

procedure TDonationDataEditForm.RefreshClaimStatusPreviewFromServer(const ADisplayInLockedView: Boolean);
var
  lRetval: TXDataClientResponse;
  lRequest: TDonationClaimStatusPreviewRequest;
  lGeneration: Integer;
  lFingerprint: string;
  lClaimStatus: string;
  lPersistedClaimStatus: string;
  lErrorText: string;
  lCalculatingShown: Boolean;

  procedure RestoreDisplayAfterPendingPreview;
  begin
    if not lCalculatingShown then
      Exit;

    if Assigned(EditDataSource.DataSet) and EditDataSource.DataSet.Active and
      (EditDataSource.DataSet.FindField('ClaimStatus') <> nil) then
      ShowPersistedClaimStatusDisplay
    else
      ApplyClaimStatusPreviewResult('Unknown', '');
  end;
begin
  lCalculatingShown := False;
  if IsReadOnlyMode then
    Exit;
  if FLockedViewMode and not ADisplayInLockedView then
    Exit;
  if not Assigned(EditDataSource.DataSet) then
    Exit;
  if EditDataSource.DataSet.FindField('ClaimStatus') = nil then
    Exit;

  lPersistedClaimStatus := Trim(EditDataSource.DataSet.FieldByName('ClaimStatus').AsString);
  if ADisplayInLockedView then
  begin
    if not ClaimStatusExpectsErrorText(lPersistedClaimStatus) then
      Exit;
    if (EditDataSource.DataSet.FindField('ErrorText') <> nil) and
      (Trim(EditDataSource.DataSet.FieldByName('ErrorText').AsString) <> '') then
      Exit;
  end;

  lRequest := BuildClaimStatusPreviewRequest;
  try
    try
      lFingerprint := lRequest.BuildFingerprint;
      if lFingerprint = FLastClaimStatusPreviewFingerprint then
        Exit;

      Inc(FClaimStatusPreviewGeneration);
      lGeneration := FClaimStatusPreviewGeneration;
      ShowClaimStatusCalculating(ADisplayInLockedView);
      lCalculatingShown := True;

      lRetval := await(TXDataClientResponse,
        MainData.WebClient.RawInvokeAsync('IGiftAiderService.PreviewDonationClaimStatus', [lRequest.ToJSONObject]));
    except
      RestoreDisplayAfterPendingPreview;
      raise;
    end;
  finally
    lRequest.Free;
  end;

  if lGeneration <> FClaimStatusPreviewGeneration then
  begin
    RestoreDisplayAfterPendingPreview;
    Exit;
  end;

  if not Assigned(EditDataSource.DataSet) or not EditDataSource.DataSet.Active then
  begin
    RestoreDisplayAfterPendingPreview;
    Exit;
  end;
  if EditDataSource.DataSet.FindField('ClaimStatus') = nil then
  begin
    RestoreDisplayAfterPendingPreview;
    Exit;
  end;

  lClaimStatus := XDataResponseString(lRetval.ResultAsObject, 'ClaimStatus');
  lErrorText := XDataResponseString(lRetval.ResultAsObject, 'ErrorText');
  if ADisplayInLockedView then
    ApplyPersistedClaimStatusErrorText(lPersistedClaimStatus, lClaimStatus, lErrorText)
  else
    ApplyClaimStatusPreviewResult(lClaimStatus, lErrorText);
  lCalculatingShown := False;
  FLastClaimStatusPreviewFingerprint := lFingerprint;
end;

procedure TDonationDataEditForm.InitAttributesForm;
  procedure AfterAttributeFormCreated(AForm: TObject);
  begin
    FAttributesForm := TEssentialsAttributesForm(AForm);
    FAttributesForm.Name := 'DonationAttributesForm';
    FAttributesForm.EntityClassName := 'TDonation';
    FAttributesForm.EntityId := EditDataSource.DataSet.FieldByName('Id').AsInteger;
  end;
begin
  if Assigned(FAttributesForm) then
  begin
    FAttributesForm.EntityClassName := 'TDonation';
    FAttributesForm.EntityId := EditDataSource.DataSet.FieldByName('Id').AsInteger;
  end
  else
    Application.CreateForm(TEssentialsAttributesForm, 'essentials.attributes.container', FAttributesForm,
      @AfterAttributeFormCreated);
end;

procedure TDonationDataEditForm.LoadEssentials;
begin
  Await(EssentialsManager.FormSetUp(Self));
  TRequiredFieldsUtils.UpdateRequiredFieldsValidity(Self);
end;

procedure TDonationDataEditForm.OtherDonationKindEditExit(Sender: TObject);
begin
  if OtherDonationKindEdit.Enabled = False then
    EditDataSource.DataSet.FieldByName('OtherDonationKind').AsString := '';
end;

procedure TDonationDataEditForm.PaymentMethodComboChange(Sender: TObject);
begin
  DeterminePaymentMethodNoteVisibility;
  CheckEdit;

  if PaymentMethodCombo.Value <> TDOnationUIUtils.OTHER then
    EditDataSource.DataSet.FieldByName('PaymentMethodNote').AsString := '';
end;

procedure TDonationDataEditForm.PaymentMethodNoteEditExit(Sender: TObject);
begin
  if PaymentMethodNoteEdit.Enabled = False then
    EditDataSource.DataSet.FieldByName('PaymentMethodNote').AsString := '';
end;

procedure TDonationDataEditForm.SaveButtonClick(Sender: TObject);
begin
  if FLockedViewMode and CanUseEditToggle then
  begin
    EnterEditMode;
    Exit;
  end;

  TrySave;
end;

procedure TDonationDataEditForm.TrySave;
var
  lAmountValue: Currency;
begin
  // Clear empty combo selections before validation
  EssentialsManager.LookUpManager.ClearEmptyComboSelections(Self);

  if not TRequiredFieldsUtils.ValidateAndShowMessage(Self) then
    Exit;

  if IsClaimStatusPreviewPending then
  begin
    FLastClaimStatusPreviewFingerprint := '';
    await(RefreshClaimStatusPreviewFromServer);
  end
  else
    CancelClaimStatusPreview;

  SyncFieldsToDatasetBeforeSave;

  if IsGiftAidUnclaimed then
  begin
    lAmountValue := EditDataSource.DataSet.FieldByName('Amount').AsFloat;
    EditDataSource.DataSet.FieldByName('GiftAid').AsFloat := RoundTo(lAmountValue * 0.25, -2);
  end
  else
  begin
    EditDataSource.DataSet.FieldByName('GiftAid').AsFloat := 0.00;
  end;

  await(CaptureSingleDeclarationIdForSave);

  EditDataSource.DataSet.Post;
  if EditDataSource.DataSet is TXDataWebDataSet then
    TXDataWebDataSet(EditDataSource.DataSet).ApplyUpdates;
  fEditDataApplyUpdates := true;
  SaveButton.Enabled := False;
  FDonationId := EditDataSource.DataSet.FieldByName('Id').AsInteger;
  DonationRefresh.Enabled := True;

  if CanUseEditToggle then
    await(EnterLockedViewModeAfterSave)
  else
  begin
    FLastClaimStatusPreviewFingerprint := '';
    await(RefreshClaimStatusPreviewFromServer);
  end;

end;

procedure TDonationDataEditForm.SetDataSet(Value: TDataSet);
begin
  CancelClaimStatusPreview;
  EditDataSource.DataSet := Value;
  SyncPreviewIdsFromDataSet;
  LoadEssentials;
  InitAttributesForm;
  DetermineConditionalUIVisibility;

  if CanUseEditToggle or IsReadOnlyMode or IsPersistedClaimStatusLocked then
    EnterLockedViewMode
  else
  begin
    EditModeOn;
    CheckEdit;
    UpdateDataState;
  end;

  UpdateClaimStatusDisplay;
end;

destructor TDonationDataEditForm.Destroy;
begin
  FreeAndNil(FAttributesForm);
  FValidation.Free;
  inherited;
end;

procedure TDonationDataEditForm.DetermineConditionalUIVisibility;
begin
  DetermineOtherDonationKindVisibility;
  DeterminePaymentMethodNoteVisibility;
end;

procedure TDonationDataEditForm.DetermineOtherDonationKindVisibility;
var
  LDonationKindValue: string;
begin
  LDonationKindValue := Trim(DonationKindCombo.Value);
  if (LDonationKindValue = '') and Assigned(EditDataSource.DataSet) and
    Assigned(EditDataSource.DataSet.FindField('DonationKind')) then
    LDonationKindValue := Trim(EditDataSource.DataSet.FieldByName('DonationKind').AsString);

  OtherDonationKindEdit.Visible := SameText(LDonationKindValue, TDonationUIUtils.OTHER);
  TDocUtils.ShowHideLabel('OtherDonationKindEdit', OtherDonationKindEdit.Visible);
  TDocUtils.ShowHideLabel('donation.otherdonationkind.row', OtherDonationKindEdit.Visible);
  TDocUtils.ShowHideLabel('donation.otherdonationkind.label', OtherDonationKindEdit.Visible);
end;

procedure TDonationDataEditForm.DeterminePaymentMethodNoteVisibility;
var
  LPaymentMethodValue: string;
begin
  LPaymentMethodValue := Trim(PaymentMethodCombo.Value);
  if (LPaymentMethodValue = '') and Assigned(EditDataSource.DataSet) and
    Assigned(EditDataSource.DataSet.FindField('PaymentMethod')) then
    LPaymentMethodValue := Trim(EditDataSource.DataSet.FieldByName('PaymentMethod').AsString);

  PaymentMethodNoteEdit.Visible := SameText(LPaymentMethodValue, TDonationUIUtils.OTHER);
  TDocUtils.ShowHideLabel('PaymentMethodNoteEdit', PaymentMethodNoteEdit.Visible);
  TDocUtils.ShowHideLabel('donation.paymentmethodnote.row', PaymentMethodNoteEdit.Visible);
  TDocUtils.ShowHideLabel('donation.paymentmethodnote.label', PaymentMethodNoteEdit.Visible);
end;

function TDonationDataEditForm.IsGiftAidUnclaimed: Boolean;
begin
  Result := SameText(Trim(FPreviewClaimStatus), 'Unclaimed');
end;

procedure TDonationDataEditForm.NonGiftaidableByCustomerRequestEditClick(Sender: TObject);
begin
  SyncCheckboxFieldsToDataset;
  CheckEdit;
end;

procedure TDonationDataEditForm.DonationDateEditChange(Sender: TObject);
begin
  CheckEdit;
  UpdateClaimStatusDisplay;
end;

procedure TDonationDataEditForm.DonationKindComboChange(Sender: TObject);
begin
  DetermineOtherDonationKindVisibility;
  CheckEdit;
  if DonationKindCombo.Value <> TDonationUIUtils.OTHER then
    EditDataSource.DataSet.FieldByName('OtherDonationKind').AsString := '';
end;

procedure TDonationDataEditForm.WebFormShow(Sender: TObject);
begin
  inherited;
  FClaimStatusRecomputed := False;
  TDonationUIUtils.AddPaymentMethodLookupsToCombo(PaymentMethodCombo.LookupValues);
  TDonationUIUtils.AddDonationKindLookupsToCombo(DonationKindCombo.LookupValues);
  DetermineConditionalUIVisibility;

  if CanUseEditToggle or IsReadOnlyMode or IsPersistedClaimStatusLocked then
    EnterLockedViewMode
  else if Assigned(EditDataSource.DataSet) then
  begin
    ShowPersistedClaimStatusDisplay;
    ScheduleClaimStatusDisplayRefresh;
    UpdateDataState;
  end;
end;

procedure TDonationDataEditForm.DonationRefreshTimer(Sender: TObject);
begin
  DonationRefresh.Enabled := False;
  if not Assigned(EditDataSource.DataSet) then
    Exit;
  if not EditDataSource.DataSet.Active then
    Exit;
  if EditDataSource.DataSet.IsEmpty then
    Exit;
  if EditDataSource.DataSet.FindField('Id') = nil then
    Exit;
  if FDonationId > 0 then
    EditDataSource.DataSet.Locate('Id', FDonationId, []);
end;

procedure TDonationDataEditForm.CheckEdit;
var
  errorTextAmount: string;
  errorTextDate: string;
  errorTextPaymentMethod: string;
  errorTextDonationKind: string;
  lDateOfDeath: TDate;
begin
  if not Assigned(EditDataSource.DataSet) or not EditDataSource.DataSet.Active then
    Exit;

  UpdatePrimaryActionEnabled;
  if IsReadOnlyMode or FLockedViewMode then
    Exit;

  FValidation.ValidateAmount(AmountDonation.Text, errorTextAmount);
  ErrorMessageAmount.Caption := errorTextAmount;
  if SameText(Trim(FDonorSnapshot.ClaimStatus), 'Deceased') then
    lDateOfDeath := FDonorSnapshot.DateOfDeath
  else
    lDateOfDeath := 0;
  FValidation.ValidateDonationDate(DonationDateEdit.Date, lDateOfDeath, errorTextDate);
  ErrorMessageDonationDate.Caption := errorTextDate;
  FValidation.ValidatePaymentMethod(PaymentMethodCombo.ItemIndex, errorTextPaymentMethod);
  ErrorMessagePaymentMethod.Caption := errorTextPaymentMethod;
  FValidation.ValidateDonationKind(DonationKindCombo.ItemIndex, DonationKindCombo.Value, errorTextDonationKind);
  ErrorMessageDonationKind.Caption := errorTextDonationKind;
  CheckValidations;
end;

procedure TDonationDataEditForm.SetAllowEdit(AAllowEdit: Boolean);
begin
  FAllowEdit := AAllowEdit;
  if not FAllowEdit then
    FLockedViewMode := True;

  if Assigned(EditDataSource.DataSet) then
  begin
    if EditDataSource.DataSet.State = dsInsert then
    begin
      if IsReadOnlyMode then
        EnterLockedViewMode
      else
      begin
        EditModeOn;
        UpdateDataState;
      end;
    end
    else if IsReadOnlyMode or IsPersistedClaimStatusLocked or CanUseEditToggle then
      EnterLockedViewMode
    else
    begin
      EditModeOn;
      UpdateDataState;
    end;
  end;
end;

function TDonationDataEditForm.IsReadOnlyMode: Boolean;
begin
  Result := not FAllowEdit;
end;

procedure TDonationDataEditForm.UpdateDataState;
begin
  if not Assigned(EditDataSource.DataSet) then
    Exit;

  case EditDataSource.DataSet.State of
    dsEdit:
      DataState.HTML.Text := 'Editing';
    dsInsert:
      DataState.HTML.Text := 'Adding';
  else
    if not FAllowEdit then
      DataState.HTML.Text := 'Viewing (Read Only)'
    else
      DataState.HTML.Text := 'Viewing';
  end;
end;

procedure TDonationDataEditForm.EditModeOn;
begin
  FLockedViewMode := False;
  EditDataSource.AutoEdit := True;
  SetEditingControlsEnabled(True);
  SaveButton.Visible := True;
  SetPrimaryActionButton('Save');
  UpdatePrimaryActionEnabled;
  CancelButton.Caption := 'Cancel';
end;

procedure TDonationDataEditForm.ViewModeOn;
begin
  FLockedViewMode := True;
  EditDataSource.AutoEdit := False;
  SetEditingControlsEnabled(False);
  SaveButton.Visible := CanUseEditToggle and not IsReadOnlyMode;
  UpdatePrimaryActionEnabled;
  if CanUseEditToggle then
    SetPrimaryActionButton('Edit');
  CancelButton.Caption := 'Close';
  UpdateDataState;
end;

procedure TDonationDataEditForm.EnterLockedViewMode;
begin
  ViewModeOn;
  DetermineConditionalUIVisibility;
  ShowPersistedClaimStatusDisplay;
  ScheduleClaimStatusDisplayRefresh;
end;

procedure TDonationDataEditForm.EnterLockedViewModeAfterSave;
begin
  ViewModeOn;
  DetermineConditionalUIVisibility;
  ShowPersistedClaimStatusDisplay;
  await(RefreshClaimStatusPreviewFromServer(True));
end;

procedure TDonationDataEditForm.EnterEditMode;
begin
  if not CanUseEditToggle then
    Exit;

  EditModeOn;
  DetermineConditionalUIVisibility;
  if not (EditDataSource.DataSet.State in dsEditModes) then
    EditDataSource.DataSet.Edit;
  CheckEdit;
  UpdateDataState;
  UpdateClaimStatusDisplay;
end;

function TDonationDataEditForm.CanUseEditToggle: Boolean;
var
  lClaimStatusField: TField;
begin
  Result := FAllowEdit and Assigned(EditDataSource.DataSet) and EditDataSource.DataSet.Active and
    (EditDataSource.DataSet.State <> dsInsert);

  if not Result then
    Exit;

  lClaimStatusField := EditDataSource.DataSet.FindField('ClaimStatus');
  if Assigned(lClaimStatusField) then
    Result := not TDonationUIUtils.DonationClaimStatusIsLocked(lClaimStatusField.AsString);
end;

function TDonationDataEditForm.CanOpenInterrogation: Boolean;
var
  lIdField: TField;
begin
  Result := Assigned(EditDataSource.DataSet) and EditDataSource.DataSet.Active and
    (EditDataSource.DataSet.State <> dsInsert);
  if not Result then
    Exit;

  lIdField := EditDataSource.DataSet.FindField('Id');
  Result := Assigned(lIdField) and (not lIdField.IsNull) and (lIdField.AsInteger > 0);
end;

procedure TDonationDataEditForm.SetPrimaryActionButton(const ACaption: string);
begin
  // Icon is supplied by global CSS based on SaveButton aria-label.
  SaveButton.Caption := ACaption;
  if Assigned(SaveButton.ElementHandle) then
    SaveButton.ElementHandle.setAttribute('aria-label', ACaption);
end;

procedure TDonationDataEditForm.SetEditingControlsEnabled(const AEnabled: Boolean);
begin
  AmountDonation.Enabled := AEnabled;
  DonorPostCode.Enabled := AEnabled;
  ClaimStatus.Enabled := AEnabled;
  DonationDateEdit.Enabled := AEnabled;
  ErrorMessageDonationDate.Enabled := AEnabled;
  ErrorMessageAmount.Enabled := AEnabled;
  ErrorMessageDonationKind.Enabled := AEnabled;
  ErrorMessagePaymentMethod.Enabled := AEnabled;
  SponsoredEditDB.Enabled := AEnabled;
  NonGiftaidableByCustomerRequestEdit.Enabled := AEnabled;
  BankingDateEdit.Enabled := AEnabled;
  OtherDonationKindEdit.Enabled := AEnabled;
  PaymentMethodNoteEdit.Enabled := AEnabled;
  DonationKindCombo.Enabled := AEnabled;
  PaymentMethodCombo.Enabled := AEnabled;
  CommentMemo.Enabled := AEnabled;
  AnalysisCode1Combo.Enabled := AEnabled;
  AnalysisCode2Combo.Enabled := AEnabled;
  BankingReference2Edit.Enabled := AEnabled;
  BankingReferenceCombo.Enabled := AEnabled;
  // Keep status display clickable for interrogation even in view mode.
  DonationClaimStatusDisplay.Enabled := True;
  DonorClaimStatusDisplay.Enabled := False;
end;

procedure TDonationDataEditForm.UpdatePrimaryActionEnabled;
begin
  if IsReadOnlyMode then
    SaveButton.Enabled := False
  else if FLockedViewMode then
    SaveButton.Enabled := CanUseEditToggle
  else
    SaveButton.Enabled := FValidation.PassesValidation;
end;

procedure TDonationDataEditForm.DonationClaimStatusDisplayClick(Sender: TObject);
var
  lPreviewRequest: TDonationClaimStatusPreviewRequest;
begin
  {$IFDEF PAS2JS}
  asm
    if (window.getSelection) {
      window.getSelection().removeAllRanges();
    }
  end;
  {$ENDIF}
  if CanOpenInterrogation then
    await(OpenClaimStatusInterrogation)
  else if Assigned(EditDataSource) and Assigned(EditDataSource.DataSet) and
    (EditDataSource.DataSet.State = dsInsert) then
  begin
    lPreviewRequest := BuildClaimStatusPreviewRequest;
    try
      await(OpenClaimStatusInterrogation(lPreviewRequest));
    finally
      lPreviewRequest.Free;
    end;
  end;
end;

procedure TDonationDataEditForm.OpenClaimStatusInterrogation(
  const APreviewRequest: TDonationClaimStatusPreviewRequest);
var
  lForm: TDonationClaimStatusInterrogationForm;
  lDonationId: Integer;
begin
  lDonationId := 0;
  if not Assigned(APreviewRequest) then
  begin
    if not CanOpenInterrogation then
      Exit;
    if not Assigned(EditDataSource) or not Assigned(EditDataSource.DataSet) then
      Exit;
    lDonationId := EditDataSource.DataSet.FieldByName('Id').AsInteger;
  end;

  lForm := TDonationClaimStatusInterrogationForm.Create(nil);
  try
    lForm.Popup := True;
    lForm.PopupOpacity := 1;
    lForm.ElementClassName := 'PopUpForm';
    lForm.DonationId := lDonationId;
    lForm.PreviewRequest := APreviewRequest;
    await(TForm, lForm.Load());
    await(TModalResult, lForm.Execute);

    // Always sync visible status/error from interrogation result, even when not recalculated.
    if Assigned(EditDataSource) and Assigned(EditDataSource.DataSet) and (Trim(lForm.CurrentClaimStatus) <> '') then
      ApplyPersistedClaimStatusErrorText(lForm.CurrentClaimStatus, lForm.CurrentClaimStatus, lForm.CurrentErrorText);

    if lForm.StatusRecomputed and Assigned(EditDataSource) and Assigned(EditDataSource.DataSet) and
      (EditDataSource.DataSet is TXDataWebDataSet) then
    begin
      FClaimStatusRecomputed := True;
      // Ensure persisted recompute result is shown and not overwritten by a pending preview.
      CancelClaimStatusPreview;
      await(TXDataWebDataSet(EditDataSource.DataSet).LoadAsync);
      if Assigned(EditDataSource) and Assigned(EditDataSource.DataSet) then
      begin
        if EditDataSource.DataSet.Active then
          EditDataSource.DataSet.Locate('Id', lForm.DonationId, []);
        FLastClaimStatusPreviewFingerprint := '';
        ShowPersistedClaimStatusDisplay;
        ScheduleClaimStatusDisplayRefresh;
      end;
    end;
  finally
    lForm.Free;
  end;
end;


procedure TDonationDataEditForm.CaptureSingleDeclarationIdForSave;
var
  lRetval: TXDataClientResponse;
  lDonationId: integer;
begin
  FSingleDeclarationId := 0;
  if not IsGiftAidUnclaimed then
    Exit;

  lDonationId := EditDataSource.DataSet.FieldByName('Id').AsInteger;

  lRetval := await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync('IGiftAiderService.FindLinkableSingleDeclarationId',
      [FDonorSnapshot.DonorId, lDonationId, DonationDateEdit.Date]));

  if Assigned(lRetval.ResultAsObject) and (lRetval.ResultAsObject['value'] <> nil) then
    FSingleDeclarationId := JS.toInteger(lRetval.ResultAsObject['value']);
end;

procedure TDonationDataEditForm.CheckValidations;
begin
  UpdatePrimaryActionEnabled;
end;

{ TDonationValidation }

constructor TDonationValidation.Create;
begin
  AmountValid := False;
  TransactionDateValid := False;
  DonationKindValid := False;
  PaymentMethodValid := False;
end;

function TDonationValidation.PassesValidation: Boolean;
begin
  Result := AmountValid and DonationKindValid and TransactionDateValid and PaymentMethodValid;
end;

procedure TDonationValidation.ValidateAmount(aAmount: string; out aErrorText: string);
var
  AdjValue: currency;
begin
  aErrorText := '';
  if aAmount <> '' then
  begin
    AdjValue := strtofloat(aAmount);
    if AdjValue > 0 then
    begin
      TDocUtils.setControlValidity('AmountDonation', vsValid);
      AmountValid := True;
    end
    else
    begin
      aErrorText := 'Amount must be greater than zero.';
      TDocUtils.setControlValidity('AmountDonation', vsInValid);
      AmountValid := False;
    end;
  end
  else
  begin
    aErrorText := 'Amount is required.';
    TDocUtils.setControlValidity('AmountDonation', vsInvalid);
    AmountValid := False;
  end;
end;

procedure TDonationValidation.ValidateDonationDate(aDonationDate, aDateOfDeath: TDate; out aErrorText: string);
begin
  aErrorText := '';
  TransactionDateValid := True;

  if aDonationDate = 0 then
  begin
    aErrorText := 'Donation Date cannot be blank.';
    TDocUtils.setControlValidity('DonationDateEdit', vsInvalid);
    TransactionDateValid := False;
  end
  else if aDonationDate > Date then
  begin
    aErrorText := 'Donation Date cannot be in the future.';
    TDocUtils.setControlValidity('DonationDateEdit', vsInvalid);
    TransactionDateValid := False;
  end
  else if (aDateOfDeath > 0) and (aDonationDate > aDateOfDeath) then
  begin
    aErrorText := 'Donation Date cannot be after date of death.';
    TDocUtils.setControlValidity('DonationDateEdit', vsInvalid);
    TransactionDateValid := False;
  end;

  if TransactionDateValid then
    TDocUtils.setControlValidity('DonationDateEdit', vsValid);
end;

procedure TDonationValidation.ValidateDonationKind(aComboItemIndex: Integer; aValue: string; out aErrorText: string);
begin
  aErrorText := '';
  DonationKindValid := aComboItemIndex <> -1;

  if DonationKindValid then
    TDocUtils.setControlValidity('DonationKindCombo', vsValid)
  else
  begin
    aErrorText := 'Donation kind must be selected.';
    TDocUtils.setControlValidity('DonationKindCombo', vsInvalid);
  end;
end;

procedure TDonationValidation.ValidatePaymentMethod(aComboItemIndex: Integer; out aErrorText: string);
begin
  aErrorText := '';
  PaymentMethodValid := aComboItemIndex <> -1;
  if PaymentMethodValid then
    TDocUtils.setControlValidity('PaymentMethodCombo', vsValid)
  else
  begin
    aErrorText := 'Payment method must be selected.';
    TDocUtils.setControlValidity('PaymentMethodCombo', vsInvalid);
  end;
end;

procedure TDonationDataEditForm.DonationDateEditExit(Sender: TObject);
begin
  DonationDateEdit.Date := TGARulesUtils.MinDateCheck(DonationDateEdit.Date);
  CheckEdit;
end;

procedure TDonationDataEditForm.BankingDateEditExit(Sender: TObject);
begin
  BankingDateEdit.Date := TGARulesUtils.MinDateCheck(BankingDateEdit.Date);
  CheckEdit;
end;


procedure TDonationDataEditForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  ErrorMessageDonationDate := TLabel.Create('ErrorMessageDonationDate');
  ErrorMessageAmount := TLabel.Create('ErrorMessageAmount');
  ErrorMessageDonationKind := TLabel.Create('ErrorMessageDonationKind');
  ErrorMessagePaymentMethod := TLabel.Create('ErrorMessagePaymentMethod');
  DonationClaimStatusError := TLabel.Create('DonationClaimStatusError');
  DataState := THTMLSpan.Create('DataState');
  AmountDonation := TDBEdit.Create('AmountDonation');
  DonorPostCode := TDBEdit.Create('DonorPostCode');
  SaveButton := TButton.Create('SaveButton');
  CancelButton := TButton.Create('CancelButton');
  ClaimStatus := TDBEdit.Create('ClaimStatus');
  DonationDateEdit := TDBDateTimePicker.Create('DonationDateEdit');
  SponsoredEditDB := TDBCheckBox.Create('SponsoredEditDB');
  BankingDateEdit := TDBDateTimePicker.Create('BankingDate');
  OtherDonationKindEdit := TDBEdit.Create('OtherDonationKindEdit');
  PaymentMethodNoteEdit := TDBEdit.Create('PaymentMethodNoteEdit');
  BankingReferenceCombo := TDBComboBox.Create('BankingReferenceCombo');
  DonationKindCombo := TDBLookupComboBox.Create('DonationKindCombo');
  PaymentMethodCombo := TDBLookupComboBox.Create('PaymentMethodCombo');
  CommentMemo := TDBMemo.Create('CommentMemo');
  AnalysisCode1Combo := TDBComboBox.Create('AnalysisCode1Combo');
  AnalysisCode2Combo := TDBComboBox.Create('AnalysisCode2Combo');
  BankingReference2Edit := TDBEdit.Create('BankingReference2Edit');
  DonationClaimStatusDisplay := TEdit.Create('DonationClaimStatusDisplay');
  DonorClaimStatusDisplay := TEdit.Create('DonorClaimStatusDisplay');
  NonGiftaidableByCustomerRequestEdit := TDBCheckBox.Create('NonGiftaidableByCustomerRequestEdit');
  EditDataSource := TDataSource.Create(Self);
  DonationRefresh := TTimer.Create(Self);
  ClaimStatusPreviewTimer := TTimer.Create(Self);

  ErrorMessageDonationDate.BeforeLoadDFMValues;
  ErrorMessageAmount.BeforeLoadDFMValues;
  ErrorMessageDonationKind.BeforeLoadDFMValues;
  ErrorMessagePaymentMethod.BeforeLoadDFMValues;
  DonationClaimStatusError.BeforeLoadDFMValues;
  DataState.BeforeLoadDFMValues;
  AmountDonation.BeforeLoadDFMValues;
  DonorPostCode.BeforeLoadDFMValues;
  SaveButton.BeforeLoadDFMValues;
  CancelButton.BeforeLoadDFMValues;
  ClaimStatus.BeforeLoadDFMValues;
  DonationDateEdit.BeforeLoadDFMValues;
  SponsoredEditDB.BeforeLoadDFMValues;
  BankingDateEdit.BeforeLoadDFMValues;
  OtherDonationKindEdit.BeforeLoadDFMValues;
  PaymentMethodNoteEdit.BeforeLoadDFMValues;
  BankingReferenceCombo.BeforeLoadDFMValues;
  DonationKindCombo.BeforeLoadDFMValues;
  PaymentMethodCombo.BeforeLoadDFMValues;
  CommentMemo.BeforeLoadDFMValues;
  AnalysisCode1Combo.BeforeLoadDFMValues;
  AnalysisCode2Combo.BeforeLoadDFMValues;
  BankingReference2Edit.BeforeLoadDFMValues;
  DonationClaimStatusDisplay.BeforeLoadDFMValues;
  DonorClaimStatusDisplay.BeforeLoadDFMValues;
  NonGiftaidableByCustomerRequestEdit.BeforeLoadDFMValues;
  EditDataSource.BeforeLoadDFMValues;
  DonationRefresh.BeforeLoadDFMValues;
  ClaimStatusPreviewTimer.BeforeLoadDFMValues;
  try
    Name := 'DonationDataEditForm';
    Width := 567;
    Height := 682;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    ErrorMessageDonationDate.SetParentComponent(Self);
    ErrorMessageDonationDate.Name := 'ErrorMessageDonationDate';
    ErrorMessageDonationDate.Left := 344;
    ErrorMessageDonationDate.Top := 8;
    ErrorMessageDonationDate.Width := 144;
    ErrorMessageDonationDate.Height := 15;
    ErrorMessageDonationDate.Caption := 'ErrorMessageDonationDate';
    ErrorMessageDonationDate.HeightPercent := 100.000000000000000000;
    ErrorMessageDonationDate.WidthPercent := 100.000000000000000000;
    ErrorMessageAmount.SetParentComponent(Self);
    ErrorMessageAmount.Name := 'ErrorMessageAmount';
    ErrorMessageAmount.Left := 168;
    ErrorMessageAmount.Top := 8;
    ErrorMessageAmount.Width := 3;
    ErrorMessageAmount.Height := 15;
    ErrorMessageAmount.HeightPercent := 100.000000000000000000;
    ErrorMessageAmount.WidthPercent := 100.000000000000000000;
    ErrorMessageDonationKind.SetParentComponent(Self);
    ErrorMessageDonationKind.Name := 'ErrorMessageDonationKind';
    ErrorMessageDonationKind.Left := 191;
    ErrorMessageDonationKind.Top := 120;
    ErrorMessageDonationKind.Width := 3;
    ErrorMessageDonationKind.Height := 15;
    ErrorMessageDonationKind.HeightPercent := 100.000000000000000000;
    ErrorMessageDonationKind.WidthPercent := 100.000000000000000000;
    ErrorMessagePaymentMethod.SetParentComponent(Self);
    ErrorMessagePaymentMethod.Name := 'ErrorMessagePaymentMethod';
    ErrorMessagePaymentMethod.Left := 191;
    ErrorMessagePaymentMethod.Top := 197;
    ErrorMessagePaymentMethod.Width := 3;
    ErrorMessagePaymentMethod.Height := 15;
    ErrorMessagePaymentMethod.HeightPercent := 100.000000000000000000;
    ErrorMessagePaymentMethod.WidthPercent := 100.000000000000000000;
    DonationClaimStatusError.SetParentComponent(Self);
    DonationClaimStatusError.Name := 'DonationClaimStatusError';
    DonationClaimStatusError.Left := 191;
    DonationClaimStatusError.Top := 221;
    DonationClaimStatusError.Width := 3;
    DonationClaimStatusError.Height := 15;
    DonationClaimStatusError.ElementClassName := 'text-muted small mb-0 donation-claim-status-error';
    DonationClaimStatusError.HeightPercent := 100.000000000000000000;
    DonationClaimStatusError.WidthPercent := 100.000000000000000000;
    DataState.SetParentComponent(Self);
    DataState.Name := 'DataState';
    DataState.Left := 408;
    DataState.Top := 622;
    DataState.Width := 136;
    DataState.Height := 25;
    DataState.HeightStyle := ssAuto;
    DataState.WidthStyle := ssAuto;
    DataState.ChildOrder := 6;
    DataState.ElementPosition := epIgnore;
    DataState.ElementFont := efCSS;
    DataState.Role := '';
    AmountDonation.SetParentComponent(Self);
    AmountDonation.Name := 'AmountDonation';
    AmountDonation.Left := 40;
    AmountDonation.Top := 8;
    AmountDonation.Width := 121;
    AmountDonation.Height := 22;
    AmountDonation.AutoCompletion := acNone;
    AmountDonation.AutoSelect := False;
    AmountDonation.ChildOrder := 1;
    AmountDonation.ElementClassName := 'form-control';
    AmountDonation.ElementFont := efCSS;
    AmountDonation.ElementPosition := epIgnore;
    AmountDonation.HeightStyle := ssAuto;
    AmountDonation.HeightPercent := 100.000000000000000000;
    AmountDonation.Text := 'AmountDonation';
    AmountDonation.WidthStyle := ssAuto;
    AmountDonation.WidthPercent := 100.000000000000000000;
    SetEvent(AmountDonation, Self, 'OnChange', 'AmountDonationChange');
    SetEvent(AmountDonation, Self, 'OnExit', 'AmountDonationChange');
    SetEvent(AmountDonation, Self, 'OnKeyPress', 'AmountDonationKeyPress');
    AmountDonation.DataField := 'Amount';
    AmountDonation.DataSource := EditDataSource;
    DonorPostCode.SetParentComponent(Self);
    DonorPostCode.Name := 'DonorPostCode';
    DonorPostCode.Left := 40;
    DonorPostCode.Top := 64;
    DonorPostCode.Width := 121;
    DonorPostCode.Height := 22;
    DonorPostCode.AutoCompletion := acNone;
    DonorPostCode.AutoSelect := False;
    DonorPostCode.ChildOrder := 3;
    DonorPostCode.ElementClassName := 'form-control';
    DonorPostCode.ElementFont := efCSS;
    DonorPostCode.ElementPosition := epIgnore;
    DonorPostCode.HeightStyle := ssAuto;
    DonorPostCode.HeightPercent := 100.000000000000000000;
    DonorPostCode.TabOrder := 2;
    DonorPostCode.Text := 'DonorPostCode';
    DonorPostCode.Visible := False;
    DonorPostCode.WidthStyle := ssAuto;
    DonorPostCode.WidthPercent := 100.000000000000000000;
    SaveButton.SetParentComponent(Self);
    SaveButton.Name := 'SaveButton';
    SaveButton.Left := 40;
    SaveButton.Top := 622;
    SaveButton.Width := 96;
    SaveButton.Height := 25;
    SaveButton.Caption := 'Save';
    SaveButton.ChildOrder := 4;
    SaveButton.ElementClassName := 'btn btn-primary';
    SaveButton.ElementFont := efCSS;
    SaveButton.ElementPosition := epIgnore;
    SaveButton.Enabled := False;
    SaveButton.HeightStyle := ssAuto;
    SaveButton.HeightPercent := 100.000000000000000000;
    SaveButton.WidthStyle := ssAuto;
    SaveButton.WidthPercent := 100.000000000000000000;
    SetEvent(SaveButton, Self, 'OnClick', 'SaveButtonClick');
    CancelButton.SetParentComponent(Self);
    CancelButton.Name := 'CancelButton';
    CancelButton.Left := 152;
    CancelButton.Top := 622;
    CancelButton.Width := 96;
    CancelButton.Height := 25;
    CancelButton.Caption := 'Cancel';
    CancelButton.ChildOrder := 5;
    CancelButton.ElementClassName := 'btn btn-primary';
    CancelButton.ElementFont := efCSS;
    CancelButton.ElementPosition := epIgnore;
    CancelButton.HeightStyle := ssAuto;
    CancelButton.HeightPercent := 100.000000000000000000;
    CancelButton.WidthStyle := ssAuto;
    CancelButton.WidthPercent := 100.000000000000000000;
    SetEvent(CancelButton, Self, 'OnClick', 'CancelButtonClick');
    ClaimStatus.SetParentComponent(Self);
    ClaimStatus.Name := 'ClaimStatus';
    ClaimStatus.Left := 40;
    ClaimStatus.Top := 92;
    ClaimStatus.Width := 300;
    ClaimStatus.Height := 22;
    ClaimStatus.AutoCompletion := acNone;
    ClaimStatus.AutoSelect := False;
    ClaimStatus.ChildOrder := 4;
    ClaimStatus.ElementClassName := 'form-control';
    ClaimStatus.ElementFont := efCSS;
    ClaimStatus.ElementPosition := epIgnore;
    ClaimStatus.HeightStyle := ssAuto;
    ClaimStatus.HeightPercent := 100.000000000000000000;
    ClaimStatus.TabOrder := 3;
    ClaimStatus.Text := 'ClaimStatus';
    ClaimStatus.Visible := False;
    ClaimStatus.WidthStyle := ssAuto;
    ClaimStatus.WidthPercent := 100.000000000000000000;
    ClaimStatus.DataField := 'ClaimStatus';
    ClaimStatus.DataSource := EditDataSource;
    DonationDateEdit.SetParentComponent(Self);
    DonationDateEdit.Name := 'DonationDateEdit';
    DonationDateEdit.Left := 40;
    DonationDateEdit.Top := 36;
    DonationDateEdit.Width := 121;
    DonationDateEdit.Height := 22;
    DonationDateEdit.ElementClassName := 'form-control';
    DonationDateEdit.HeightStyle := ssAuto;
    DonationDateEdit.WidthStyle := ssAuto;
    DonationDateEdit.BorderStyle := bsSingle;
    DonationDateEdit.ChildOrder := 8;
    DonationDateEdit.Color := clWhite;
    DonationDateEdit.Date := 45191.330952881940000000;
    DonationDateEdit.ElementFont := efCSS;
    DonationDateEdit.ElementPosition := epIgnore;
    DonationDateEdit.Role := '';
    DonationDateEdit.Text := 'DonationDateEdit';
    SetEvent(DonationDateEdit, Self, 'OnChange', 'DonationDateEditChange');
    SetEvent(DonationDateEdit, Self, 'OnExit', 'DonationDateEditExit');
    DonationDateEdit.DataField := 'TransactionDate';
    DonationDateEdit.DataSource := EditDataSource;
    SponsoredEditDB.SetParentComponent(Self);
    SponsoredEditDB.Name := 'SponsoredEditDB';
    SponsoredEditDB.Left := 40;
    SponsoredEditDB.Top := 364;
    SponsoredEditDB.Width := 113;
    SponsoredEditDB.Height := 22;
    SponsoredEditDB.ChildOrder := 15;
    SponsoredEditDB.ElementClassName := 'form-check-input';
    SponsoredEditDB.ElementFont := efCSS;
    SponsoredEditDB.ElementPosition := epIgnore;
    SponsoredEditDB.HeightStyle := ssAuto;
    SponsoredEditDB.HeightPercent := 100.000000000000000000;
    SponsoredEditDB.TabOrder := 14;
    SponsoredEditDB.WidthStyle := ssAuto;
    SponsoredEditDB.WidthPercent := 100.000000000000000000;
    SponsoredEditDB.DataField := 'Sponsored';
    SponsoredEditDB.DataSource := EditDataSource;
    BankingDateEdit.SetParentComponent(Self);
    BankingDateEdit.Name := 'BankingDateEdit';
    BankingDateEdit.Left := 40;
    BankingDateEdit.Top := 336;
    BankingDateEdit.Width := 170;
    BankingDateEdit.Height := 22;
    BankingDateEdit.ElementClassName := 'form-control';
    BankingDateEdit.BorderStyle := bsSingle;
    BankingDateEdit.ChildOrder := 17;
    BankingDateEdit.Color := clWhite;
    BankingDateEdit.Date := 45978.612005416670000000;
    BankingDateEdit.Role := '';
    BankingDateEdit.Text := 'dd/mm/yyyy';
    SetEvent(BankingDateEdit, Self, 'OnExit', 'BankingDateEditExit');
    BankingDateEdit.DataField := 'BankingDate';
    BankingDateEdit.DataSource := EditDataSource;
    OtherDonationKindEdit.SetParentComponent(Self);
    OtherDonationKindEdit.Name := 'OtherDonationKindEdit';
    OtherDonationKindEdit.Left := 40;
    OtherDonationKindEdit.Top := 160;
    OtherDonationKindEdit.Width := 504;
    OtherDonationKindEdit.Height := 22;
    OtherDonationKindEdit.AutoSelect := False;
    OtherDonationKindEdit.ChildOrder := 17;
    OtherDonationKindEdit.ElementClassName := 'form-control';
    OtherDonationKindEdit.HeightPercent := 100.000000000000000000;
    OtherDonationKindEdit.WidthPercent := 100.000000000000000000;
    SetEvent(OtherDonationKindEdit, Self, 'OnExit', 'OtherDonationKindEditExit');
    OtherDonationKindEdit.DataField := 'OtherDonationKind';
    OtherDonationKindEdit.DataSource := EditDataSource;
    PaymentMethodNoteEdit.SetParentComponent(Self);
    PaymentMethodNoteEdit.Name := 'PaymentMethodNoteEdit';
    PaymentMethodNoteEdit.Left := 40;
    PaymentMethodNoteEdit.Top := 225;
    PaymentMethodNoteEdit.Width := 504;
    PaymentMethodNoteEdit.Height := 22;
    PaymentMethodNoteEdit.AutoSelect := False;
    PaymentMethodNoteEdit.ChildOrder := 17;
    PaymentMethodNoteEdit.ElementClassName := 'form-control';
    PaymentMethodNoteEdit.HeightPercent := 100.000000000000000000;
    PaymentMethodNoteEdit.WidthPercent := 100.000000000000000000;
    SetEvent(PaymentMethodNoteEdit, Self, 'OnExit', 'PaymentMethodNoteEditExit');
    PaymentMethodNoteEdit.DataField := 'PaymentMethodNote';
    PaymentMethodNoteEdit.DataSource := EditDataSource;
    BankingReferenceCombo.SetParentComponent(Self);
    BankingReferenceCombo.Name := 'BankingReferenceCombo';
    BankingReferenceCombo.Left := 216;
    BankingReferenceCombo.Top := 336;
    BankingReferenceCombo.Width := 328;
    BankingReferenceCombo.Height := 33;
    BankingReferenceCombo.ElementClassName := 'form-select';
    BankingReferenceCombo.HeightPercent := 100.000000000000000000;
    BankingReferenceCombo.Text := 'BankingReferenceCombo';
    BankingReferenceCombo.WidthPercent := 100.000000000000000000;
    BankingReferenceCombo.ItemIndex := -1;
    BankingReferenceCombo.DataField := 'BankingReference';
    BankingReferenceCombo.DataSource := EditDataSource;
    DonationKindCombo.SetParentComponent(Self);
    DonationKindCombo.Name := 'DonationKindCombo';
    DonationKindCombo.Left := 40;
    DonationKindCombo.Top := 120;
    DonationKindCombo.Width := 145;
    DonationKindCombo.Height := 22;
    DonationKindCombo.HeightPercent := 100.000000000000000000;
    DonationKindCombo.WidthPercent := 100.000000000000000000;
    SetEvent(DonationKindCombo, Self, 'OnChange', 'DonationKindComboChange');
    DonationKindCombo.DataField := 'DonationKind';
    DonationKindCombo.DataSource := EditDataSource;
    PaymentMethodCombo.SetParentComponent(Self);
    PaymentMethodCombo.Name := 'PaymentMethodCombo';
    PaymentMethodCombo.Left := 40;
    PaymentMethodCombo.Top := 197;
    PaymentMethodCombo.Width := 145;
    PaymentMethodCombo.Height := 22;
    PaymentMethodCombo.HeightPercent := 100.000000000000000000;
    PaymentMethodCombo.WidthPercent := 100.000000000000000000;
    SetEvent(PaymentMethodCombo, Self, 'OnChange', 'PaymentMethodComboChange');
    PaymentMethodCombo.DataField := 'PaymentMethod';
    PaymentMethodCombo.DataSource := EditDataSource;
    CommentMemo.SetParentComponent(Self);
    CommentMemo.Name := 'CommentMemo';
    CommentMemo.Left := 40;
    CommentMemo.Top := 406;
    CommentMemo.Width := 419;
    CommentMemo.Height := 196;
    CommentMemo.ElementClassName := 'form-control';
    CommentMemo.HeightPercent := 100.000000000000000000;
    CommentMemo.Lines.BeginUpdate;
    try
      CommentMemo.Lines.Clear;
      CommentMemo.Lines.Add('CommentMemo');
    finally
      CommentMemo.Lines.EndUpdate;
    end;
    CommentMemo.SelLength := 0;
    CommentMemo.SelStart := 0;
    CommentMemo.WidthPercent := 100.000000000000000000;
    CommentMemo.DataField := 'Comment';
    CommentMemo.DataSource := EditDataSource;
    AnalysisCode1Combo.SetParentComponent(Self);
    AnalysisCode1Combo.Name := 'AnalysisCode1Combo';
    AnalysisCode1Combo.Left := 40;
    AnalysisCode1Combo.Top := 253;
    AnalysisCode1Combo.Width := 300;
    AnalysisCode1Combo.Height := 33;
    AnalysisCode1Combo.HeightPercent := 100.000000000000000000;
    AnalysisCode1Combo.Text := 'AnalysisCode1Combo';
    AnalysisCode1Combo.WidthPercent := 100.000000000000000000;
    AnalysisCode1Combo.ItemIndex := -1;
    AnalysisCode1Combo.DataField := 'AnalysisCode1';
    AnalysisCode1Combo.DataSource := EditDataSource;
    AnalysisCode2Combo.SetParentComponent(Self);
    AnalysisCode2Combo.Name := 'AnalysisCode2Combo';
    AnalysisCode2Combo.Left := 40;
    AnalysisCode2Combo.Top := 293;
    AnalysisCode2Combo.Width := 300;
    AnalysisCode2Combo.Height := 33;
    AnalysisCode2Combo.HeightPercent := 100.000000000000000000;
    AnalysisCode2Combo.Text := 'AnalysisCode2Combo';
    AnalysisCode2Combo.WidthPercent := 100.000000000000000000;
    AnalysisCode2Combo.ItemIndex := -1;
    AnalysisCode2Combo.DataField := 'AnalysisCode2';
    AnalysisCode2Combo.DataSource := EditDataSource;
    BankingReference2Edit.SetParentComponent(Self);
    BankingReference2Edit.Name := 'BankingReference2Edit';
    BankingReference2Edit.Left := 216;
    BankingReference2Edit.Top := 364;
    BankingReference2Edit.Width := 328;
    BankingReference2Edit.Height := 22;
    BankingReference2Edit.AutoSelect := False;
    BankingReference2Edit.ChildOrder := 17;
    BankingReference2Edit.ElementClassName := 'form-control';
    BankingReference2Edit.HeightPercent := 100.000000000000000000;
    BankingReference2Edit.WidthPercent := 100.000000000000000000;
    BankingReference2Edit.DataField := 'BankingReference2';
    BankingReference2Edit.DataSource := EditDataSource;
    DonationClaimStatusDisplay.SetParentComponent(Self);
    DonationClaimStatusDisplay.Name := 'DonationClaimStatusDisplay';
    DonationClaimStatusDisplay.Left := 191;
    DonationClaimStatusDisplay.Top := 197;
    DonationClaimStatusDisplay.Width := 145;
    DonationClaimStatusDisplay.Height := 22;
    DonationClaimStatusDisplay.Hint := 'Click to interrogate';
    DonationClaimStatusDisplay.ShowHint := True;
    DonationClaimStatusDisplay.TabStop := False;
    DonationClaimStatusDisplay.AutoSelect := False;
    DonationClaimStatusDisplay.ElementClassName := 'form-control';
    DonationClaimStatusDisplay.ElementPosition := epIgnore;
    DonationClaimStatusDisplay.HeightStyle := ssAuto;
    DonationClaimStatusDisplay.HeightPercent := 100.000000000000000000;
    DonationClaimStatusDisplay.ReadOnly := True;
    DonationClaimStatusDisplay.WidthStyle := ssAuto;
    DonationClaimStatusDisplay.WidthPercent := 100.000000000000000000;
    SetEvent(DonationClaimStatusDisplay, Self, 'OnClick', 'DonationClaimStatusDisplayClick');
    DonorClaimStatusDisplay.SetParentComponent(Self);
    DonorClaimStatusDisplay.Name := 'DonorClaimStatusDisplay';
    DonorClaimStatusDisplay.Left := 352;
    DonorClaimStatusDisplay.Top := 197;
    DonorClaimStatusDisplay.Width := 145;
    DonorClaimStatusDisplay.Height := 22;
    DonorClaimStatusDisplay.TabStop := False;
    DonorClaimStatusDisplay.AutoSelect := False;
    DonorClaimStatusDisplay.ElementClassName := 'form-control';
    DonorClaimStatusDisplay.ElementPosition := epIgnore;
    DonorClaimStatusDisplay.HeightStyle := ssAuto;
    DonorClaimStatusDisplay.HeightPercent := 100.000000000000000000;
    DonorClaimStatusDisplay.ReadOnly := True;
    DonorClaimStatusDisplay.WidthStyle := ssAuto;
    DonorClaimStatusDisplay.WidthPercent := 100.000000000000000000;
    NonGiftaidableByCustomerRequestEdit.SetParentComponent(Self);
    NonGiftaidableByCustomerRequestEdit.Name := 'NonGiftaidableByCustomerRequestEdit';
    NonGiftaidableByCustomerRequestEdit.Left := 40;
    NonGiftaidableByCustomerRequestEdit.Top := 392;
    NonGiftaidableByCustomerRequestEdit.Width := 400;
    NonGiftaidableByCustomerRequestEdit.Height := 22;
    NonGiftaidableByCustomerRequestEdit.ChildOrder := 16;
    NonGiftaidableByCustomerRequestEdit.ElementClassName := 'form-check-input';
    NonGiftaidableByCustomerRequestEdit.ElementFont := efCSS;
    NonGiftaidableByCustomerRequestEdit.ElementPosition := epIgnore;
    NonGiftaidableByCustomerRequestEdit.HeightStyle := ssAuto;
    NonGiftaidableByCustomerRequestEdit.HeightPercent := 100.000000000000000000;
    NonGiftaidableByCustomerRequestEdit.TabOrder := 15;
    NonGiftaidableByCustomerRequestEdit.WidthStyle := ssAuto;
    NonGiftaidableByCustomerRequestEdit.WidthPercent := 100.000000000000000000;
    SetEvent(NonGiftaidableByCustomerRequestEdit, Self, 'OnClick', 'NonGiftaidableByCustomerRequestEditClick');
    NonGiftaidableByCustomerRequestEdit.DataField := 'NonGiftaidableByCustomerRequest';
    NonGiftaidableByCustomerRequestEdit.DataSource := EditDataSource;
    EditDataSource.SetParentComponent(Self);
    EditDataSource.Name := 'EditDataSource';
    SetEvent(EditDataSource, Self, 'OnDataChange', 'EditDataSourceDataChange');
    EditDataSource.Left := 216;
    EditDataSource.Top := 24;
    DonationRefresh.SetParentComponent(Self);
    DonationRefresh.Name := 'DonationRefresh';
    DonationRefresh.Enabled := False;
    DonationRefresh.Interval := 100;
    SetEvent(DonationRefresh, Self, 'OnTimer', 'DonationRefreshTimer');
    DonationRefresh.Left := 512;
    DonationRefresh.Top := 552;
    ClaimStatusPreviewTimer.SetParentComponent(Self);
    ClaimStatusPreviewTimer.Name := 'ClaimStatusPreviewTimer';
    ClaimStatusPreviewTimer.Enabled := False;
    ClaimStatusPreviewTimer.Interval := 250;
    SetEvent(ClaimStatusPreviewTimer, Self, 'OnTimer', 'ClaimStatusPreviewTimerTimer');
    ClaimStatusPreviewTimer.Left := 592;
    ClaimStatusPreviewTimer.Top := 552;
  finally
    ErrorMessageDonationDate.AfterLoadDFMValues;
    ErrorMessageAmount.AfterLoadDFMValues;
    ErrorMessageDonationKind.AfterLoadDFMValues;
    ErrorMessagePaymentMethod.AfterLoadDFMValues;
    DonationClaimStatusError.AfterLoadDFMValues;
    DataState.AfterLoadDFMValues;
    AmountDonation.AfterLoadDFMValues;
    DonorPostCode.AfterLoadDFMValues;
    SaveButton.AfterLoadDFMValues;
    CancelButton.AfterLoadDFMValues;
    ClaimStatus.AfterLoadDFMValues;
    DonationDateEdit.AfterLoadDFMValues;
    SponsoredEditDB.AfterLoadDFMValues;
    BankingDateEdit.AfterLoadDFMValues;
    OtherDonationKindEdit.AfterLoadDFMValues;
    PaymentMethodNoteEdit.AfterLoadDFMValues;
    BankingReferenceCombo.AfterLoadDFMValues;
    DonationKindCombo.AfterLoadDFMValues;
    PaymentMethodCombo.AfterLoadDFMValues;
    CommentMemo.AfterLoadDFMValues;
    AnalysisCode1Combo.AfterLoadDFMValues;
    AnalysisCode2Combo.AfterLoadDFMValues;
    BankingReference2Edit.AfterLoadDFMValues;
    DonationClaimStatusDisplay.AfterLoadDFMValues;
    DonorClaimStatusDisplay.AfterLoadDFMValues;
    NonGiftaidableByCustomerRequestEdit.AfterLoadDFMValues;
    EditDataSource.AfterLoadDFMValues;
    DonationRefresh.AfterLoadDFMValues;
    ClaimStatusPreviewTimer.AfterLoadDFMValues;
  end;
end;

end.
